import { createTheme } from "@material-ui/core";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

//css breakpoints
const breakpoints = createBreakpoints({});

const theme = createTheme({
  palette: {
    primary: {
      main: "#F2137B",
      contrastText: "#fff",
    },
    secondary: {
      main: "#992468",
      contrastText: "#fff",
      light: "#FAF4F7",
      dark: "#EBD3E1",
    },
    info: {
      main: "#F5D9E9",
    },
    grey: {
      600: "#A1A29D",
      100: "#FAFAFA",
    },
    error: {
      main: "#DA3030",
      contrastText: "#fff",
    },
    success: {
      main: "#307D2B",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: "Raleway, sans-serif",
    h1: {
      fontSize: 48.83,
      letterSpacing: -2,
      fontWeight: "bold",
    },
    h2: {
      fontSize: 39.06,
      letterSpacing: -2,
      fontWeight: "bold",
    },
    h3: {
      fontSize: 31.25,
      letterSpacing: -1,
      fontWeight: "bold",
    },
    h4: {
      fontSize: 25,
      letterSpacing: -1,
      fontWeight: "bold",
    },
    h5: {
      fontSize: 22,
      letterSpacing: -0.5,
      fontWeight: 600,
    },
    body1: {
      fontSize: 16,
      fontWeight: "normal",
    },
    body2: {
      fontSize: 16,
      fontWeight: "bold",
    },
    subtitle1: {
      fontSize: 16,
      fontWeight: 700,
    },
    subtitle2: {
      fontSize: 15,
      fontWeight: 500,
    },
    button: {
      marginTop: 16,
      marginBottom: 16,
      marginLeft: 16,
      paddingLeft: 16,
      paddingRight: 16,
      background: "#FAFAFA",
      borderRadius: 4,
      textTransform: "capitalize",
      fontSize: 14,
      display: "flex",
      alignItems: "center",
      [breakpoints.only("xs")]: {
        paddingTop: 12,
        paddingBottom: 12,
        marginBottom: 0,
        marginLeft: 0,
      },
    },
  },
  overrides: {
    MuiButton: {
      iconSizeMedium: {
        "& > *:first-child": {
          fontSize: 16,
        },
      },
      outlined: {
        background: "none !important",
        color: "#F2137B !important",
        border: "1px solid #F2137B",
        "&:hover": {
          background: "#fff",
          border: "1px solid #992468",
          color: "#992468 !important",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        marginTop: 0,
        height: 0,
      },
      contained: {
        margin: "2px 0px 8px 0px !important",
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: 20,
      },
    },
    MuiFilledInput: {
      multiline: {
        paddingTop: 10,
      },
      input: {
        paddingTop: 10,
      },
    },
    MuiDialog: {
      paperWidthLg: {
        width: 1110,
        paddingLeft: 30,
        paddingRight: 25,
      },
    },
    MuiDialogActions: {
      root: {
        padding: "24px 0px 24px 24px",
      },
    },
    MuiButtonBase: {
      root: {
        padding: 4,
      },
    },
    MuiRadio: {
      root: { padding: 4, marginLeft: 4 },
    },
    MuiOutlinedInput: {
      root: {
        "&:hover $notchedOutline": {
          borderColor: "#F2137B",
        },
      },
    },
    MuiTabs: {
      flexContainer: {
        justifyContent: "flex-end",
        [breakpoints.only("xs")]: {
          justifyContent: "space-between",
        },
      },
    },
    MuiTab: {
      root: {
        "&$selected": {
          backgroundColor: "#F2137B",
          color: "#fff",
        },
      },
    },
    MuiTableRow: {
      root: {
        [breakpoints.only("xs")]: {
          display: "block",
        },
      },
    },
    MuiTableBody: {
      root: {
        [breakpoints.only("xs")]: {
          display: "block",
        },
      },
    },
    MuiImageListItem: {
      root: {
        [breakpoints.only("xs")]: {
          marginBottom: 8,
        },
      },
    },
    MuiStepLabel: {
      label: {
        "&$active": {
          fontWeight: 800,
        },
      },
    },
    MuiStepper: {
      root: {
        padding: 40,
      },
    },
    MuiStepConnector: {
      vertical: {
        marginLeft: 9,
        marginTop: 6,
      },
    },
    MuiCard: {
      root: {
        display: "flex",
        textAlign: "center",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "22vw",
        padding: "0px 8px",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        [breakpoints.only("md")]: {
          height: "30vw",
        },
        [breakpoints.only("sm")]: {
          height: "50vw",
        },
        [breakpoints.only("xs")]: {
          height: "84vw",
        },
      },
    },
  },
});

export default theme;
